import { render, staticRenderFns } from "./dashboardB2C.vue?vue&type=template&id=262eb57c&"
import script from "./dashboardB2C.vue?vue&type=script&lang=js&"
export * from "./dashboardB2C.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports